module.exports = __webpack_public_path__ + "img/profess5.1f2a09cc.png";